import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const nuo: Collection = {
  id: 'ona-nuo',
  brandId: 'ona',
  brandName: 'Ona',
  icon: 'ona.png',
  title: 'Nuo',
  subTitle: 'Speels & kleurrijk',
  banner: 'nuo/nuo-banner.jpg',
  items: [
    {
      id: 'ona-nuo-1',
      collectionImages: [
        {
          image: 'nuo/Nuo_blanc.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'nuo/Nuo-blue.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'ona-nuo-2',
      collectionImages: [
        {
          image: 'nuo/Nuo_8.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },

        {
          image: 'nuo/Nuo_4.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'nuo/Nuo_9.jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    'aa35b255-6eb6-4ea2-8c2a-7a9d5046d309',
    'a4402c84-cd5d-497d-82c8-19bae0a5dfd9',
    '741f8c48-88ef-427a-b7f7-da95dd4180c3',
    '403d9bc5-8c57-49f9-bbd2-43578a47b84d',
    '0949c9a5-d6d4-43b7-b256-c884ace5b6c0',
    '572a9dfe-b3a8-4bd4-b818-5311d8207bdf',
    '448b4518-3d6b-4e9d-b38b-4a500c649313',
    '8382ca12-eecc-4d8d-9e13-9146e11cb056',
    '9241c9ce-1bd2-4730-862e-fb358f0d1ae9',
    '69752e43-308b-439d-bb3a-80fe7b0f79ac',
    'bab67289-6f38-4da8-9e36-6f2e7ba69146',
    '523a2089-289f-4b09-94f7-1a4237c66f21',
    '1c34f56c-4ae2-4e04-8159-03c42f76a1d2'
  ]
};
